import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight';

import toast from 'react-hot-toast';

import { WidgetCard } from 'us-react-components/dist/WidgetCard/WidgetCard';
import { FBLoginResponse } from 'us-web-services';
import { FacebookSdk } from 'us-react-components/dist/utils/FacebookSdk';
import { useDependencies } from '../../../../../dependencies';
import { FacebookUtil } from '../../../../../utils/FacebookUtil';
import { Button, ButtonType } from '../../../../Button';

export const FacebookWidget = (): JSX.Element => {
  const { t } = useTranslation();
  const { stores, services: { tracker } } = useDependencies();

  const handleLoginResponse = (facebookResponse: FBLoginResponse): void => {
    FacebookUtil.linkFacebook(facebookResponse, stores.user, t);
  }

  const handleClick = async (): Promise<void> => {
    const trackingProps = {
      elementId: 'facebook-widget',
      elementText: t('dashboard.widgets.facebook.connect')
    };
    tracker.track('clicked-button', trackingProps);

    try {
      const sdk = await FacebookSdk.ensureReady();

      sdk.login(handleLoginResponse);
    } catch {
      toast.error(t('notifications.facebook.sdkUnavailable'));
    }
  }

  return (
    <WidgetCard
      title={t('dashboard.widgets.facebook.title')}
      description={t('dashboard.widgets.facebook.description')}
      hasButton
      buttonComponent={<Button
        buttonType={ButtonType.tertiary}
        className='text-facebookBlue hover:text-facebookBlue-300 active:text-facebookBlue-300'
        onClick={handleClick}>
        <FontAwesomeIcon icon={faFacebook} size='2xl' />
        &nbsp; {t('dashboard.widgets.facebook.connect')}
        <FontAwesomeIcon icon={faAngleRight} className='pl-2 m-[-1px]' />
      </Button>
      }
    />
  );
};
